module.exports = __webpack_public_path__ + "img/backspace.321a4804.svg";